import React from 'react';
import { Route, Link, Prompt } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../Common/Sidebar';
import ContactCar from './ContactCar';
import NavBar from '../Common/NavBar';
import Footer from '../Common/Footer';
import loadable from '@loadable/component'
import { getUrlState, detectMobile, isValidCharacter, fbGaEvents } from '../../../utils';
import { forge_sha256 } from '../../../forge-sha256';
import { ApplicationForm, IncomesForm, CollateralForm, CarDataForm } from './Forms';

// borrower forms are heavy, let's defer loading
const BorrowerForm = loadable(() => import('./Forms').then(modules => modules.BorrowerForm));
const CoborrowerStaffForm = loadable(() => import('./Forms').then(modules => modules.CoborrowerStaffForm));
const CoborrowerForm = loadable(() => import('./Forms').then(modules => modules.CoborrowerForm));
const Simulator = loadable(() => import('../Simulator'));
const Proposal = loadable(() => import('../Proposal'));
const Selector = loadable(() => import('../Selector'));

import { PRESTAMO_URL, PERSONAL_URL, INCOME_URL, COBORROWER_URL, COLLATERAL_URL, PROPUESTA_URL, PREAPROBACION_URL, SELECTOR_URL, SIMULATOR_URL,
CAR_URL, UW_CONTACT_URL, TOP_LEVEL_PREFIX, CAR_CONTACT_URL } from '../../../config';
import s from './ChatsForm.scss';
import { connect } from 'react-redux';
import { fetchUser } from '../../../redux/actions/user-actions';
import {fetchApplication} from '../../../redux/actions/application-actions';
import { abtest } from '../../../utils';
import StaffActions from '../StaffActions';

const sessionid = document.cookie.split('; ').find(cookie => cookie.includes('sessionid='))

class ChatsForm extends React.Component {

    state = {
        status: 11,
        has_user: false,
        carModal : false,
        carModal2 : false,
        userModal: false,
        disabled: true,
        is_user: 'INACTIVE',
        lastScrollY:0,
        showSidebar: false,
        modalEmail: '',
        closedModal: '',
        application: {
            app_type: this.props.match.params.apptype.toUpperCase(),
            abtest: '',
            destination: null,
            with_collateral: null,
            with_coborrower: null,
            upfront_value: '',
            upfront_currency: 'USD',
            requested_value: '',
            requested_currency: '',
            reason: null,
            comments: '',
            car_interested : '',
        },
        borrower: {
            phone: '',
            email: '',
            dni: '',
            first_name: '',
            last_name: '',
            occupation: '',
            civil_status: '',
            childrens: null,
            contact_time: '',
            postal_code: '',
        },
        incomes: [],
        coborrower: {
            first_name: '',
            last_name: '',
            dni: '',
            relation: null,
            occupation: '',
            civil_status: '',
            incomes: [],
        },
        newIncome: {
            income_type: null,
            category: null,
            income: '',
            seniority: null,
            justify_incomes: null,
        },
        newCoborrowerIncome: {
            income_type: '',
            category: '',
            income: '',
            seniority: '',
        },
        collateral: {
            collateral_value: '',
            collateral_currency: 'USD',
            more_info: '',
            property_type: '',
            address: '',
            total_m2: '',
            covered_m2: '',
            age: '',
            rooms: '',
            garages: '',
            zone: null,
            unique_home: '',
            owner: '',
            inscribed_title: '',
        },
        carCollateral: {
            patent: '',
            year: '2020',
            brand: '',
            model: '',
            version: '',
            purpose: '',
            gnc: '',
            is_financed: '',
            remaining_debt: '',
            brandCurrency: 'ars',
            price : '',
            zone : '',
        },
        carOptions:{
            year : ['2020', '2019', '2018', '2017', '2016', '2015', '2014', '2013', '2012', '2011', '2010', '2009', '2008', '2007', '2006', '2005', '2004'],
            brand : [],
            model : [],
            version :[],
            zone : [],
            purpose: [],
            default : {id:0, name: 'Seleccionar...'}
        },
        exchange: {
            USD: {
                USD: 0,
                ARS: 0,
                UVA: 0,
            },
            ARS: {
                USD: 0,
                ARS: 0,
                UVA: 0,
            },
            UVA: {
                USD: 0,
                ARS: 0,
                UVA: 0,
            },

        },
        errors: {
            application: {},
            borrower: {},
            newIncome: {},
            coborrower: {},
            collateral: {},
            carCollateral: {},
            newCoborrowerIncome: {},
            carCollateral: {},
            email: {},
        },
        sidebarList: {
            application: {
                span: 1,
                name: 'Destino del {0}',
                name_parser: abtest,
                completed: false,
                path: PRESTAMO_URL,
                status: 11,
            },
            borrower: {
                span: 2,
                name: 'Datos personales',
                completed: false,
                path: PERSONAL_URL,
                status: 12,

            },
            incomes: {
                span: 3,
                name: 'Tus ingresos',
                completed: false,
                path: INCOME_URL,
                status: 13,
            },
            coborrower: {
                span: 4,
                name: 'Datos del co-titular',
                completed: false,
                path: COBORROWER_URL,
                status: 14,
            },
            [(this.props.match.params.apptype.toUpperCase() == 'HD') ? 'collateral' : 'carCollateral']:{
                span: 5,
                name: (this.props.match.params.apptype.toUpperCase() == 'HD') ? 'Datos de la propiedad' : 'Datos del vehículo',
                completed: false,
                path: (this.props.match.params.apptype.toUpperCase() == 'HD') ? COLLATERAL_URL : CAR_URL,
                status: 16,
            },
            proposal: {
                span: 6,
                name: 'Tu propuesta',
                completed: false,
                path: PROPUESTA_URL,
                status: 20,
            },
        },
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            application: {
                ...prevState.application,
                app_type: nextProps.match.params.apptype.toUpperCase(),
            },
        };
    }

    carHandleChange = (evt) => {
        evt.preventDefault();
        let field = evt.target.name;
        let value = evt.target.value;
        if(isValidCharacter(field, value)){
            this.setState({
                carCollateral : {
                    ...this.state.carCollateral,
                    [field] : value
                }
            });
        }
        if(field === 'year'){
            axios.get(`/api/v2/ce/brands/${value}/`)
            .then(({data})=> {
                this.setState({
                    carOptions : {
                        ...this.state.carOptions,
                        brand : [this.state.carOptions.default, ...data.results]
                    },
                    carCollateral : {
                        ...this.state.carCollateral,
                        model : '',
                        version : '',
                        brand: '',
                    }
                });
            });
        }
    }

    carBrandChange = (evt) => {
        evt.preventDefault();
        let { year } = this.state.carCollateral;
        let brand = this.state.carOptions.brand.find(elem=>elem.id == evt.target.value);
        this.setState({
            carCollateral : {
                ...this.state.carCollateral,
                brand: brand.id,
                version : '',
                model : '',
            }
        });
        if(evt.target.value != 0){
            axios.get(`/api/v2/ce/brands/${evt.target.value}/year/${year}/models/`)
            .then(({data})=> {
                this.setState({
                    carOptions : {
                        ...this.state.carOptions,
                        model : [this.state.carOptions.default, ...data.results],
                        version : [this.state.carOptions.default]
                    }
                });
            });
        }
    }

    carModelChange = (evt) => {
        evt.preventDefault();
        let { year, brand } = this.state.carCollateral;
        let model = this.state.carOptions.model.find(elem=>elem.id == evt.target.value);
        this.setState({
            carCollateral: {
                ...this.state.carCollateral,
                model: model.id,
                version : ''
            }
        });
        if(evt.target.value != 0){
            axios.get(`/api/v2/ce/brands/${brand}/year/${year}/models/${evt.target.value}/versions/`)
            .then(({data})=> {
                this.setState({
                    carOptions : {
                        ...this.state.carOptions,
                        version : [this.state.carOptions.default, ...data.results]
                    }
                });
            });
        }
    }

    carVersionChange = (evt) => {
        evt.preventDefault();
        let versionOption = this.state.carOptions.version;
        let versionId = evt.target.value;
        let versionPrice = versionOption.find(vers=>vers.id == versionId);
        this.setState({
            carCollateral : {
                ...this.state.carCollateral,
                version: evt.target.value,
                price: versionPrice.price
            }
        });
    }

    closeCarModal = () => {
        this.setState({
            carModal:false,
            carModal2:false
        });
    }

    handleCarInterested = (e) => {
        if(this.state.application.car_interested){
            return window.location.href = 'https://autos.agilis.com.ar/'
        }
        if(e.target.name === 'modal1'){
            this.setState({
            carModal : true,
            application: {
                ...this.state.application,
                with_collateral : false
                }
            });
        }else{
            this.setState({
            carModal2 : true,
            });
        }
        axios.post('/api/v2/car-interested/', this.state.application);
    }

    handleChangeForCarInterested = (e) => {
        if(e.target.name == 'car_interested'){
            this.setState({
                application :{
                    ...this.state.application,
                    with_collateral:false,
                    car_interested : e.target.value
                }
            });
        }else{
            this.setState({
                application:{
                    ...this.state.application,
                    car_interested : e.target.value
                }
            });
        }
    }

    setAmount = () => {
        this.setState({
            application : {
                ...this.state.application,
                requested_currency : 'ARS',
                requested_value : '250000'
            },
            carModal2 : false,
            errors : {
                ...this.state.errors,
                application : {}
            }
        });
    }

    setHome = () => {
        this.setState({
            application : {
                ...this.state.application,
                with_collateral: true
            },
            carModal : false
        });
    }

    componentDidMount() {
        // Inicializando el estado de todos los formularios basado en lo que devuelve leadgen
        let apptype = this.props.match.params.apptype;

        if((apptype === 'cp')){
            let sideBarListCp = this.state.sidebarList;
            delete sideBarListCp['application']
            this.setState({
                 sidebarList: sideBarListCp, 
            });
        }

        this.props.fetchApplication(apptype)
        .then(res => {
            axios.post('/api/v2/page-view/', { view: window.location.href, referrer: document.referrer });
            let forms = res.application;
            let status = forms.status || this.state.status;
            let url_app_type = this.props.match.params.apptype.toUpperCase();
            let application = {
                ...this.state.application,
                ...forms.application,
            }
            if (application.app_type != url_app_type) {
                status = 0;
                application = {
                    ...this.state.application,
                    ...forms.application,
                    app_type: url_app_type,
                    destination: '',
                    zone: '',
                    with_collateral: true,
                };
            }
            if(url_app_type == 'CE'){
                application.requested_currency = 'ARS'
            }
            if(url_app_type == 'HD'){
                application.requested_currency = 'USD'
            }
            this.setState({
                ...this.state,
                has_user: forms.has_user,
                application,
                status,
                borrower: {
                    ...this.state.borrower,
                    ...forms.borrower,
                    dni: (forms.borrower && forms.borrower.dni) || '',
                },
                incomes: forms.incomes || [],
                coborrower: {
                    ...this.state.coborrower,
                    ...forms.coborrower,
                    incomes: (forms.coborrower && forms.coborrower.incomes) || []
                },
                collateral: {
                    ...this.state.collateral,
                    ...forms.collateral,
                    age: forms.collateral && forms.collateral.age || '',
                    covered_m2: forms.collateral && forms.collateral.covered_m2 || '',
                    garages: forms.collateral && forms.collateral.garages || '',
                    rooms: forms.collateral && forms.collateral.rooms || '',
                    total_m2: forms.collateral && forms.collateral.total_m2 || '',
                },
                carCollateral: {
                    ...this.state.carCollateral,
                    ...forms.car,
                },
                exchange: forms.exchange || this.state.exchange,
                sidebarList: Object.keys(this.state.sidebarList).reduce((memo, key) => {
                    memo[key] = {
                        ...this.state.sidebarList[key],
                        completed: this.state.sidebarList[key].status < status,
                    }
                    return memo;
                }, {}),
            });
        })
        //traemos las brands para CE, y el resto de los campos si corresponde.
        .then(()=>{
            if(this.state.application.app_type !== 'HD'){
                axios.get('/api/v2/ce/brands/2019/')
                .then(({ data }) => {
                    this.setState({
                        carOptions : {
                            ...this.state.carOptions,
                            brand : [this.state.carOptions.default, ...data.results],
                        }
                    });
                });
            }
            if(this.state.carCollateral.model != '' && this.state.carCollateral.version != ''){
                let { brand, year, model, version } = this.state.carCollateral
                axios.get(`/api/v2/ce/brands/${brand}/year/${year}/models/`)
                .then(({data})=> {
                    this.setState({
                        carOptions : {
                            ...this.state.carOptions,
                            model : [this.state.carOptions.default, ...data.results]
                        }
                    });
                })
                .then(()=>{
                    axios.get(`/api/v2/ce/brands/${brand}/year/${year}/models/${model}/versions/`)
                        .then(({data})=> {
                            this.setState({
                                carOptions : {
                                    ...this.state.carOptions,
                                    version : [this.state.carOptions.default, ...data.results]
                                }
                            });
                        });
                });
            }
        });
        this.props.fetchUser('leadgen')
        .then((res) =>{
            let userId = res.user && res.user.id;
            this.setState({
                application_id: res.user.application_id,
            });
            if(userId){
                this.setState({
                    is_user: 'ACTIVE',
                });
            }else{
                this.setState({
                    is_user: 'INACTIVE',
                });
            }
        });
    }

    submitCreator = (form, redirectUrl) => (values, noRedirect) => {
        this.setState({
            ...this.state,
            [form]: values,
            errors: {
                ...this.state.errors,
                [form]: {},
            }
        });
        return axios.post(`/api/v2/${form.toLowerCase()}/`, values)
            .then((res) => {
                this.setState({
                    status: res.data.status,
                    sidebarList: {
                        ...this.state.sidebarList,
                        [form]: {
                            ...this.state.sidebarList[form],
                            completed: true
                        }
                    },
                });
                let trackingEvent, step, borrowerData;
                if (form == 'application') {
                    trackingEvent = 'AddToWishlist';
                    step = 'paso1';
                }
                if (form == 'borrower') {
                    trackingEvent = 'AddToCart';
                    step = 'paso2';
                    
                    borrowerData = {
                        email: forge_sha256(res.data.email),
                        phone: forge_sha256(res.data.phone)
                    }
                    this.setState({
                            borrower: {
                            ...this.state.borrower,
                            first_name: res.data.first_name,
                            last_name: res.data.last_name,
                        }
                    });
                }
                if (form == 'collateral' || form == 'carCollateral') {
                    trackingEvent = 'SubmitApplication';
                    step = 'paso5';
                }

                fbGaEvents(this.props.is_staff, trackingEvent, this.state.application.app_type, sessionid, step, 0, borrowerData);
                if (!noRedirect) this.props.history.push(redirectUrl);
            })
            .catch((x) => {
                let response = x.response
                const errors = {}
                if(response){
                    Object.keys(response.data).forEach(field => {
                        errors[field] = response.data[field]
                        if(field == 'version'){
                            errors['version'] = ["¡Ups! Te faltó seleccionar una opción."]
                            if(!this.state.carCollateral.brand){
                                errors['brand'] = ["¡Ups! Te faltó seleccionar una opción."]
                            }
                            if(!this.state.carCollateral.model){
                                errors['model'] = ["¡Ups! Te faltó seleccionar una opción."]
                            }
                        }
                    });
                    this.setState({
                        errors: {
                            ...this.state.errors,
                            [form]: errors,
                        }
                    });
                }else{
                    console.log(x)
                }
            })
    }

    prestamoSubmit = this.submitCreator('application', `${this.props.match.url}${PERSONAL_URL}`)

    personalSubmit = (values, noRedirect) => {
        const cleanedValues = {
            ...values,
            score: values.score || null,
            commitment: values.commitment || null,
        };
        this.submitCreator('borrower', `${this.props.match.url}${INCOME_URL}`)(cleanedValues, noRedirect);
    }

    collateralSubmit = (values, noRedirect) => {
        const cleanedValues = {
            ...values,
            upfront_value: values.upfront_value || null,
            requested_value: values.requested_value || null,
            total_m2: values.total_m2 || null,
            covered_m2: values.covered_m2 || null,
            age: values.age || null,
            rooms: values.rooms || null,
            garages: values.garages || null,
        }
        this.submitCreator('collateral', { pathname: `${this.props.match.url}${PROPUESTA_URL}`, state: { showLoader: true } })(cleanedValues, noRedirect);
    }

    carSubmit = (values, noRedirect) => {
        values.is_financed ? values.remaining_debt : values.remaining_debt = null
        values.zone ? values.zone : values.zone = null
        values.patent ? values.patent : values.patent = null
        const cleanedValues = {
            ...values,
        }
        this.submitCreator('carCollateral', { pathname: `${this.props.match.url}${PROPUESTA_URL}`, state: { showLoader: true } })(cleanedValues, noRedirect);
    }

    incomeSubmit = (values) => {
        this.setState({
            newIncome: values,
            errors: {
                ...this.state.errors,
                newIncome: {},
            }
        });
        axios.post('/api/v2/borrower/incomes/', values)
            .then(({ data }) => {
                this.setState({
                    incomes: [...this.state.incomes, data],
                    newIncome: {
                        income_type: null,
                        category: null,
                        income: '',
                        seniority: null,
                    },
                })
            })
            .catch(({ response }) => {
                const errors = {}
                Object.keys(response.data).forEach(field => {
                    errors[field] = response.data[field]
                });
                this.setState({
                    errors: {
                        ...this.state.errors,
                        newIncome: errors,
                    }
                });
            });
    }

    changeWithCoborrower = (e) => {
        this.setState({
            application: {
                ...this.state.application,
                with_coborrower: e.target.value,
            }
        });
    }

    submitIncomeForm = (e) => {
        e.preventDefault();
        e.stopPropagation();
        axios.get(`/api/v2/borrower/incomes/update_status/`)
        .then((res) => {
            this.setState({
                status: res.data.status,
                sidebarList: {
                    ...this.state.sidebarList,
                    incomes: {
                        ...this.state.sidebarList.incomes,
                        completed: true,
                    }
                }
            });
            fbGaEvents(this.props.is_staff, 'AddPaymentInfo', this.state.application.app_type, sessionid, 'paso3');
            this.props.history.push(`${this.props.match.url}${COBORROWER_URL}`)
        });
    }

    deleteIncome = (number) => {
        axios.delete(`/api/v2/borrower/incomes/${number}/`)
            .then(() => {
                let new_incomes = this.state.incomes.filter(income => income.number !== number);
                let new_status = this.state.status;
                if (!new_incomes.lenght) {
                    new_status = 13;
                }
                this.setState({
                    incomes: new_incomes,
                    status: new_status,
                })
            })
    }

    coborrowerSubmit = (coborrower, income) => {
        this.setState({
            newCoborrowerIncome: income,
            coborrower: coborrower,
            errors: {
                ...this.state.errors,
                newCoborrowerIncome: {},
                coborrower: {},
            },
        });
        this.postCoborrowerInfo(coborrower)
            .then(() => this.postCoborrowerIncome(income))
            .catch(({ response }) => {
                const errors = {}
                Object.keys(response.data).forEach(field => {
                    errors[field] = response.data[field]
                });
                this.setState({
                    errors: {
                        ...this.state.errors,
                        coborrower: errors,
                    }
                });
            });
    }

    postCoborrowerInfo = coborrower =>
        axios.post(`/api/v2/coborrower/`, coborrower)
            .then(res => res.data)
            .then(coborrower => {
                this.setState({
                    status: coborrower.status,
                    coborrower: {
                        ...this.state.coborrower,
                        ...coborrower,
                    },
                });
            })

    postCoborrowerIncome = (income) =>
        axios.post(`/api/v2/coborrower/incomes/`, income)
            .then(res => res.data)
            .then((income) => {
                this.setState({
                    status: income.status,
                    coborrower: {
                        ...this.state.coborrower,
                        incomes: [...this.state.coborrower.incomes, income],
                    },
                    newCoborrowerIncome: {
                        income_type: '',
                        category: '',
                        income: '',
                        seniority: '',
                    },
                });
            })
            .catch(({ response }) => {
                const errors = {}
                Object.keys(response.data).forEach(field => {
                    errors[field] = response.data[field]
                });
                this.setState({
                    errors: {
                        ...this.state.errors,
                        newCoborrowerIncome: errors,
                    }
                });
            });

    deleteCoborrowerIncome = (number) => {
        axios.delete(`/api/v2/coborrower/incomes/${number}/`)
            .then(() => {
                this.setState({
                    coborrower: {
                        ...this.state.coborrower,
                        incomes: this.state.coborrower.incomes.filter(income => income.number !== number)
                    },
                });
            });
    }

    goToCollateralForm = (coborrower) => {
        this.setState({
            coborrower: {
                ...this.state.coborrower,
                ...coborrower,
            },
            sidebarList: {
                ...this.state.sidebarList,
                coborrower: {
                    ...this.state.sidebarList.coborrower,
                    completed: true,
                },
            },
            errors: {
                ...this.state.errors,
                coborrower: {},
            },
        });
        fbGaEvents(this.props.is_staff, 'Subscribe', this.state.application.app_type, sessionid, 'paso4');
        const { with_coborrower } = this.state.application
        if (with_coborrower) {
            this.postCoborrowerInfo(coborrower)
            .then((response) => {
                this.setState({
                    application: {
                        ...this.state.application,
                        with_coborrower,
                    },
                    sidebarList: {
                        ...this.state.sidebarList,
                        coborrower: {
                            ...this.state.sidebarList.coborrower,
                            completed: true,
                        }
                    }
                });
                if (this.state.application.app_type.toUpperCase() == 'HD') {
                    this.props.history.push(`${this.props.match.url}${COLLATERAL_URL}`);
                }else{
                    this.props.history.push(`${this.props.match.url}${CAR_URL}`);
                }

            })
            .catch(({ response }) => {
                const errors = {};
                Object.keys(response.data).forEach(field => {
                    errors[field] = response.data[field];
                });
                this.setState({
                    errors: {
                        ...this.state.errors,
                        coborrower: errors,
                    }
                });
            });
        } else {
            axios.delete('/api/v2/coborrower/')
            .then((res) => {
                this.setState({
                    status: res.data.status,
                    coborrower: {
                        first_name: '',
                        last_name: '',
                        dni: '',
                        relation: null,
                        occupation: '',
                        civil_status: '',
                        incomes: [],
                    },
                });
                if (this.state.application.app_type.toUpperCase() == 'HD') {
                    this.props.history.push(`${this.props.match.url}${COLLATERAL_URL}`);
                }else{
                    this.props.history.push(`${this.props.match.url}${CAR_URL}`);
                }
            })
        }
    }

    completeStep6 = () => {
        this.setState({
            sidebarList: {
                ...this.state.sidebarList,
                proposal: {
                    ...this.state.sidebarList.proposal,
                    completed: true,
                }
            }
        });
    }

    getCoborrower = () => {
        axios.get('/api/v2/coborrower/')
            .then(({ data }) => this.setState({ status: data.status }))

    }

    editIncome = (endpoint) => (number, income) => {
        return axios.put(`/api/v2/${endpoint}/incomes/${number}/`, income)
            .then(({ data }) => {
                if (endpoint === 'borrower') {
                    this.setState({
                        incomes: this.state.incomes.map((income) => {
                            if (income.number === data.number) return data;
                            return income;
                        }),
                    });
                } else {
                    this.setState({
                        coborrower: {
                            ...this.state.coborrower,
                            incomes: this.state.coborrower.incomes.map((income) => {
                                if (income.number === data.number) return data;
                                return income;
                            }),
                        },
                    });
                }
            });
    }

    createModalUser = () => {
        axios.post('/api/v2/create-user/')
            .then(res => {
                this.setState({
                    has_user: true,
                    disabled: false,
                });
            });
    }

    buttonClick = (e) => {
        axios.post('/api/v2/app-confirmed-post/')
            .then(res =>{
                this.props.history.push(`${TOP_LEVEL_PREFIX}/app/${this.state.application.app_type.toLowerCase()}/uw${UW_CONTACT_URL}`)
            })
    }

    openUserModal = (e) => {
        this.setState({
            userModal: true
        });
    }

    closeUserModal = (e) => {
        this.setState({
            userModal: false
        },()=> this.buttonClick());
    }

    setUserTrue = (e) =>{
        this.setState({
            has_user: true,
        });
    }

     openSidebar = (e) =>{
        this.setState({
            showSidebar: true,
        });
    }

    closeSidebar = (e) =>{
        this.setState({
            showSidebar: false,
        });
    }

  proposalMessageHandler = () => {
    this.setState({
        application: {
            ...this.state.application,
            with_coborrower: true,
        }
    }, () => { this.props.history.push(`${this.props.match.url}${COBORROWER_URL}`) });
  }

    render() {
        const { match, is_staff=false } = this.props;
        const { sidebarList, status, application, borrower, collateral, errors, newIncome, incomes, coborrower, exchange, has_user, carModal, carModal2,
        carCollateral, carOptions, is_user, modalEmail,closedModal, application_id } = this.state;
        return (
            <div>
                {!is_staff &&
                    <NavBar
                        hot={status >= 20}
                        apptype={match.params.apptype}
                        status={status}
                        userBorrower={borrower}
                        is_user={is_user}
                        match={match}
                        urlLocation={getUrlState(window.location.pathname)}
                        abtestData={application.abtest}
                        destination={application.destination}
                    />
                }
                    <div className={s.sidebar}>
                        <Sidebar
                            list={sidebarList}
                            next={status}
                            path={match.path}
                            urlLocation={match.url}
                            hot={status >= 20}
                            apptype={match.params.apptype}
                            is_user={is_user}
                            status={status}
                        />
                    </div>
                <div className={s.container}>
                    <div className={s.header}>
                            <Sidebar
                                list={sidebarList}
                                next={status}
                                path={match.path}
                                urlLocation={match.url}
                                hot={status >= 20}
                                apptype={match.params.apptype}
                                is_user={is_user}
                                closeModal={this.closeSidebar}
                                mobile={true}
                                status={status}
                            />
                    </div>
                    <div className={s.forms}>
                        {is_staff &&
                            <div className={s.staffContainer}>
                                <StaffActions app_type={application.app_type} has_user={has_user} createUser={this.createUser} setUserTrue={this.setUserTrue}/>
                            </div>
                        }
                        <Route
                            path={`${match.path}${PRESTAMO_URL}`}
                            render={() =>
                                <ApplicationForm
                                    values={application}
                                    errors={errors.application}
                                    onSubmit={this.prestamoSubmit}
                                    exchange={exchange}
                                    closeModal={this.closeCarModal}
                                    handleCarInterested={this.handleCarInterested}
                                    carModal={carModal}
                                    carModal2={carModal2}
                                    setAmount={this.setAmount}
                                    setHome={this.setHome}
                                    app_type={application.app_type}
                                    handleChangeForCarInterested={this.handleChangeForCarInterested}
                                    abtestData={application.abtest}
                                    app_type={application.app_type}
                                    modalEmail={modalEmail}
                                    closedModal={closedModal}
                                    modalEmailErrors={errors.email}
                                    is_staff={is_staff}
                                    isAppForm="true"
                                />
                            }
                        />
                        <Route
                            path={`${match.path}${PERSONAL_URL}`}
                            render={() =>
                                <BorrowerForm
                                    values={borrower}
                                    errors={errors.borrower}
                                    onSubmit={this.personalSubmit}
                                    abtestData={application.abtest}
                                    modalEmail={modalEmail}
                                    closedModal={closedModal}
                                    modalEmailErrors={errors.email}
                                    apptype={match.params.apptype}
                                />
                            }
                        />
                        <Route
                            path={`${match.path}${INCOME_URL}`}
                            render={(props) =>
                                <IncomesForm
                                    totalSteps={4}
                                    status={status}
                                    validStatus={3}
                                    incomeSubmit={this.incomeSubmit}
                                    errors={errors.newIncome}
                                    values={newIncome}
                                    incomes={incomes}
                                    with_coborrower={this.state.application.with_coborrower}
                                    deleteIncome={this.deleteIncome}
                                    submitIncomeForm={this.submitIncomeForm}
                                    editIncome={this.editIncome('borrower')}
                                    userBorrower={borrower}
                                    apptype={match.params.apptype}
                                    is_staff={is_staff}
                                    {...props}
                                />
                            }
                        />

                        <Route
                            path={`${match.path}${COLLATERAL_URL}`}
                            render={(props) =>
                                <CollateralForm
                                    errors={errors.collateral}
                                    values={collateral}
                                    onSubmit={this.collateralSubmit}
                                    apptype={match.params.apptype}
                                    destination={application.destination}
                                    withCoborrower={application.with_coborrower}
                                    exchange={exchange}
                                    with_collateral={application.with_collateral}
                                    {...props}
                                />
                            }
                        />

                        {is_staff ?
                            <Route
                                path={`${match.path}${COBORROWER_URL}`}
                                render={(props) =>
                                    <CoborrowerStaffForm
                                        with_coborrower={application.with_coborrower}
                                        changeWithCoborrower={this.changeWithCoborrower}
                                        chatUrl={match.url}
                                        apptype={match.params.apptype}
                                        {...props}
                                    />
                                }
                            />
                            :
                            <Route
                                path={`${match.path}${COBORROWER_URL}`}
                                render={(props) =>
                                    <CoborrowerForm
                                        coborrowerSubmit={this.coborrowerSubmit}
                                        errors={{ ...errors.coborrower, newIncome: errors.newCoborrowerIncome }}
                                        values={coborrower}
                                        newIncome={newIncome}
                                        deleteIncome={this.deleteCoborrowerIncome}
                                        postCoborrowerForm={this.goToCollateralForm}
                                        editIncome={this.editIncome('coborrower')}
                                        changeWithCoborrower={this.changeWithCoborrower}
                                        with_coborrower={application.with_coborrower}
                                        apptype={match.params.apptype}
                                        {...props}
                                    />
                                }
                            />
                        }

                        <Route
                            path={`${match.path}${CAR_URL}`}
                            render={(props) =>
                                <CarDataForm
                                    carHandleChange={this.carHandleChange}
                                    errors={errors.carCollateral}
                                    values={carCollateral}
                                    options={carOptions}
                                    onSubmit={this.carSubmit}
                                    apptype={match.params.apptype}
                                    destination={application.destination}
                                    withCoborrower={application.with_coborrower}
                                    exchange={exchange}
                                    with_collateral={application.with_collateral}
                                    carBrandChange={this.carBrandChange}
                                    carModelChange={this.carModelChange}
                                    carVersionChange={this.carVersionChange}
                                    {...props}
                                />
                            }
                        />
                    </div>
                    <Route
                        path={`${match.path}${PROPUESTA_URL}`}
                        exact
                        render={(props) => <Proposal name={borrower.first_name} email={borrower.email} uuid={sessionid} abtestData={application.abtest} selectorUrl={`${match.url}${SELECTOR_URL}`} requested_value={application.requested_value}
                        nextUrl={(match.params.apptype !== 'cp') ? TOP_LEVEL_PREFIX + '/app/'+ match.params.apptype.toLowerCase() + '/uw' + UW_CONTACT_URL : TOP_LEVEL_PREFIX + '/app/' +  match.params.apptype.toLowerCase() + '/completa-tus-datos' + CAR_CONTACT_URL} borrowerUrl={`${match.url}${PERSONAL_URL}`} proposalMessageHandler={this.proposalMessageHandler}
                        coborrowerUrl={`${match.url}${COBORROWER_URL}`} app_type={match.params.apptype} destination={application.destination} {...props} completeStep={this.completeStep6}  is_staff={is_staff}/>}
                    />
                    <Route
                        path={`${match.path}${PROPUESTA_URL}${SIMULATOR_URL}`}
                        render={(props) => <Simulator name={borrower.first_name} app_type={match.params.apptype} email={borrower.email} abtestData={application.abtest} uuid={sessionid} nextUrl={(match.params.apptype !== 'cp') ? TOP_LEVEL_PREFIX + '/app/'+ match.params.apptype.toLowerCase() + '/uw' + UW_CONTACT_URL : TOP_LEVEL_PREFIX + '/app/' +  match.params.apptype.toLowerCase() + '/completa-tus-datos' + CAR_CONTACT_URL} proposalMessageHandler={this.proposalMessageHandler}
                        selectorUrl={`${match.url}${SELECTOR_URL}`} destination={application.destination} is_staff={is_staff} {...props} />}
                    />
                    <Route
                        path={`${match.path}${SELECTOR_URL}`}
                        exact
                        render={(props) => <Selector proposalUrl={`${match.url}${PROPUESTA_URL}`} name={borrower.first_name} abtestData={application.abtest} app_type={match.params.apptype} {...props} />}
                    />
                    <Route
                        path={`${match.path}${CAR_CONTACT_URL}`}
                        exact
                        render={(props) => <ContactCar apptype={match.params.apptype} nextUrl={`${TOP_LEVEL_PREFIX}/app/${match.params.apptype.toLowerCase()}/completa-tus-datos${CAR_CONTACT_URL}`} application_id={application_id} {...props} />}
                    />
                    {(match.params.apptype !== 'cp') && <Footer apptype={match.params.apptype} is_user={is_user} status={status} mobile={detectMobile()} abtestData={application.abtest}/>}
                </div>
                <Prompt message={location => (
                    location.pathname !== '/' ? true : 'Estás a punto de volver a la página de inicio, ¿estás seguro que deseas continuar?'
                )} />
            </div>
        );
    }
}

const mapStateToProps = ({ user, application }) => ({userBorrower: user.borrower, is_staff: !!user.is_staff, application });
const mapDispatchToProps = { fetchUser, fetchApplication };

export default connect(mapStateToProps, mapDispatchToProps)(ChatsForm);
